import { render } from "./LogIn.vue?vue&type=template&id=2335db2f&scoped=true"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import "./LogIn.vue?vue&type=style&index=0&id=2335db2f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2335db2f"]])

export default __exports__